import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../store'

import Login from '@/pages/Login'
import MyMain from '@/pages/MyMain'
import Index from '@/pages/index/Index'
import Newimg from '@/pages/news/imgs/Newimg'
import NewSend from '@/pages/news/send/NewSend'
import SendPlace from '@/pages/innovation/SendPlace'
import Company from '@/pages/company/company/CompanyManager'
import CompanyShow from '@/pages/company/CompanyShow/CompanyShow'
import Player from '@/pages/company/CompanyShow/Player'
import Job from '@/pages/company/job/JobManager'
import User from '@/pages/user/UserManager'
import AdminUser from '@/pages/sysset/user/AdminUser'
import Role from '@/pages/sysset/role/Role'
import Ddic from '@/pages/sysset/ddic/Ddic'
import SendItem from "@/pages/innovation/SendItem";
import Recruit from '@/pages/recruit/Recruit'


Vue.use(Router)

const routerPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/',
      redirect: function (to) {
        //   //重定向
        let user = store.state.userInfo;
        let token = user.token;
        if (!token) {
          return '/login';
        } else {
          return '/index';
        }
      },
      name: 'myMain',
      component: MyMain,
      children: [
        {
          path: '/index',
          name: '首页',
          component: Index
        },
        {
          path: '/overView',
          name: '概览',
          component: ()=> import('../pages/index/OverView')
        },
        {
          path: '/newImg',
          name: '轮播图管理',
          component: Newimg
        },
        {
          path: '/newSend',
          name: '新闻发布管理',
          component: NewSend
        },
        {
          path: '/sendPlace',
          name: '发布场地',
          component: SendPlace
        },
        {
          path: '/sendCapital',
          name: '发布资金',
          component: ()=> import('../pages/innovation/SendCapital')
        },
        {
          path: '/sendPolicy',
          name: '发布政策',
          component: ()=> import('../pages/innovation/sendPolicy')
        },
        {
          path: '/sendActivity',
          name: '发布活动',
          component: ()=> import('../pages/innovation/sendActivity')
        },
        {
          path: '/sendService',
          name: '发布服务',
          component: ()=> import('../pages/innovation/sendService')
        },
        {
          path: '/sendProject',
          name: '发布项目',
          component: SendItem,
          // query:{
          //   key:'project'
          // }
        },
        {
          path: '/company',
          name: '企业管理',
          component: Company
        },
        {
          path: '/issue',
          name: '发布管理',
          component: Job
        },
        {
          path: '/companyShow',
          name: '企业秀',
          component: CompanyShow
        },
        {
          path: '/player',
          name: '播放器',
          component: Player
        },
        {
          path: '/user',
          name: '用户管理',
          component: User
        },
        {
          path: '/adminUser',
          name: '后台用户管理',
          component: AdminUser
        },
        {
          path: '/role',
          name: '角色管理',
          component: Role
        },
        {
          path: '/ddic',
          name: 'Ddic',
          component: Ddic
        },
        {
          path: '/recruit',
          name: '招聘会',
          component: Recruit
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js